import { forwardRef } from 'react'
import cn from 'clsx'

const LabelStudioEditor = forwardRef(({
    id = 'LabelStudio-editor',
    className = null,
    style = {},
    error = null,
}, ref) => {
    
    return (
        
        <div
            className={cn(
                'LabelStudio', className,
            )}
            style={style || {}}>
            
            {error && (
                <div className="text-danger">{error}</div>
            )}
            
            <div
                ref={ref}
                id={id}
                className="LabelStudio-editor parse-theme" />
        
        </div>
        
    )
    
})

LabelStudioEditor.displayName = 'LabelStudioEditor'

export default LabelStudioEditor
